import { FC } from 'react';
import { styled } from 'styled-components';

const SpinCompWrap = styled.svg`
  @keyframes rotateMove {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  animation: rotateMove 0.5s linear infinite;
`;

export const SpinComp: FC<{ className?: string; onClick?: () => void }> = ({
  className,
  onClick,
}) => {
  return (
    <SpinCompWrap
      onClick={() => onClick?.()}
      className={`${className}`}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 15.812C23.6685 15.812 23.3505 15.6803 23.1161 15.4459C22.8817 15.2115 22.75 14.8935 22.75 14.562V9.25C22.75 8.91848 22.8817 8.60054 23.1161 8.36612C23.3505 8.1317 23.6685 8 24 8C24.3315 8 24.6495 8.1317 24.8839 8.36612C25.1183 8.60054 25.25 8.91848 25.25 9.25V14.562C25.25 15.254 24.69 15.812 24 15.812Z"
        fill="#979797"
      />
      <path
        opacity="0.9"
        d="M19.906 16.9124C19.6192 17.0778 19.2785 17.1227 18.9587 17.0372C18.6389 16.9517 18.366 16.7428 18.2 16.4564L15.544 11.8564C15.396 11.5709 15.3638 11.2394 15.454 10.9307C15.5441 10.6221 15.7498 10.3601 16.0281 10.1991C16.3065 10.0382 16.6362 9.99068 16.9487 10.0665C17.2612 10.1424 17.5324 10.3357 17.706 10.6064L20.362 15.2064C20.4442 15.3484 20.4975 15.5051 20.5191 15.6677C20.5406 15.8303 20.5299 15.9955 20.4876 16.1539C20.4452 16.3124 20.3721 16.4609 20.2723 16.5911C20.1725 16.7212 20.048 16.8304 19.906 16.9124Z"
        fill="#979797"
      />
      <path
        opacity="0.85"
        d="M16.9101 19.9047C16.8281 20.0467 16.7189 20.1712 16.5888 20.271C16.4586 20.3708 16.3101 20.4439 16.1517 20.4863C15.9932 20.5286 15.828 20.5393 15.6654 20.5178C15.5028 20.4962 15.3461 20.4428 15.2041 20.3607L10.6041 17.7047C10.3174 17.5389 10.1083 17.2661 10.0228 16.9461C9.9373 16.6262 9.98239 16.2854 10.1481 15.9987C10.3139 15.712 10.5868 15.5029 10.9067 15.4174C11.2266 15.3318 11.5674 15.3769 11.8541 15.5427L16.4541 18.1987C17.0501 18.5427 17.2541 19.3087 16.9101 19.9047Z"
        fill="#979797"
      />
      <path
        opacity="0.8"
        d="M15.812 24C15.812 24.69 15.252 25.25 14.562 25.25H9.25C8.91848 25.25 8.60054 25.1183 8.36612 24.8839C8.1317 24.6495 8 24.3315 8 24C8 23.6685 8.1317 23.3505 8.36612 23.1161C8.60054 22.8817 8.91848 22.75 9.25 22.75H14.562C15.254 22.75 15.812 23.31 15.812 24Z"
        fill="#979797"
      />
      <path
        opacity="0.75"
        d="M16.91 28.0927C17.0754 28.3795 17.1203 28.7201 17.0348 29.04C16.9493 29.3598 16.7404 29.6327 16.454 29.7987L11.854 32.4547C11.5685 32.6026 11.237 32.6349 10.9283 32.5447C10.6196 32.4545 10.3576 32.2489 10.1967 31.9705C10.0357 31.6921 9.98824 31.3625 10.0641 31.05C10.1399 30.7375 10.3333 30.4663 10.604 30.2927L15.204 27.6367C15.3459 27.5545 15.5026 27.5011 15.6652 27.4796C15.8278 27.458 15.993 27.4687 16.1515 27.5111C16.3099 27.5534 16.4585 27.6266 16.5886 27.7264C16.7188 27.8262 16.828 27.9506 16.91 28.0927Z"
        fill="#979797"
      />
      <path
        opacity="0.7"
        d="M19.9057 31.0891C20.0477 31.1711 20.1721 31.2803 20.2719 31.4104C20.3717 31.5406 20.4449 31.6891 20.4872 31.8476C20.5296 32.006 20.5403 32.1712 20.5187 32.3338C20.4972 32.4964 20.4438 32.6531 20.3617 32.7951L17.7056 37.3951C17.6236 37.537 17.5143 37.6614 17.3842 37.7612C17.254 37.8609 17.1055 37.934 16.9471 37.9764C16.7887 38.0187 16.6235 38.0295 16.4609 38.008C16.2983 37.9865 16.1416 37.9331 15.9997 37.8511C15.8577 37.769 15.7333 37.6598 15.6335 37.5296C15.5338 37.3994 15.4607 37.2509 15.4183 37.0925C15.376 36.9341 15.3653 36.7689 15.3868 36.6063C15.4083 36.4438 15.4616 36.287 15.5437 36.1451L18.1996 31.5451C18.3657 31.2586 18.6385 31.0498 18.9584 30.9643C19.2782 30.8788 19.6189 30.9237 19.9057 31.0891Z"
        fill="#979797"
      />
      <path
        opacity="0.65"
        d="M24 32.1875C24.69 32.1875 25.25 32.7475 25.25 33.4375V38.7495C25.25 39.081 25.1183 39.399 24.8839 39.6334C24.6495 39.8678 24.3315 39.9995 24 39.9995C23.6685 39.9995 23.3505 39.8678 23.1161 39.6334C22.8817 39.399 22.75 39.081 22.75 38.7495V33.4375C22.75 32.7455 23.31 32.1875 24 32.1875Z"
        fill="#979797"
      />
      <path
        opacity="0.6"
        d="M28.0936 31.0891C28.3804 30.9237 28.7211 30.8788 29.0409 30.9643C29.3608 31.0498 29.6336 31.2586 29.7996 31.5451L32.4556 36.1451C32.6036 36.4306 32.6358 36.7621 32.5457 37.0707C32.4555 37.3794 32.2499 37.6414 31.9715 37.8024C31.6931 37.9633 31.3634 38.0108 31.0509 37.9349C30.7385 37.8591 30.4672 37.6657 30.2936 37.3951L27.6376 32.7951C27.5555 32.6531 27.5021 32.4964 27.4805 32.3338C27.459 32.1712 27.4697 32.006 27.5121 31.8476C27.5544 31.6891 27.6276 31.5406 27.7274 31.4104C27.8272 31.2803 27.9516 31.1711 28.0936 31.0891Z"
        fill="#979797"
      />
      <path
        opacity="0.55"
        d="M31.09 28.0927C31.1721 27.9506 31.2813 27.8262 31.4114 27.7264C31.5415 27.6266 31.6901 27.5534 31.8485 27.5111C32.007 27.4687 32.1722 27.458 32.3348 27.4796C32.4974 27.5011 32.6541 27.5545 32.796 27.6367L37.396 30.2927C37.538 30.3747 37.6624 30.484 37.7621 30.6141C37.8619 30.7443 37.935 30.8928 37.9774 31.0512C38.0197 31.2096 38.0304 31.3749 38.0089 31.5374C37.9874 31.7 37.9341 31.8567 37.852 31.9987C37.77 32.1406 37.6607 32.265 37.5306 32.3648C37.4004 32.4645 37.2519 32.5377 37.0935 32.58C36.9351 32.6223 36.7699 32.6331 36.6073 32.6116C36.4447 32.5901 36.288 32.5367 36.146 32.4547L31.546 29.7987C31.2596 29.6327 31.0507 29.3598 30.9652 29.04C30.8798 28.7201 30.9246 28.3795 31.09 28.0927Z"
        fill="#979797"
      />
      <path
        opacity="0.5"
        d="M32.188 24C32.188 23.31 32.748 22.75 33.438 22.75H38.75C39.0815 22.75 39.3995 22.8817 39.6339 23.1161C39.8683 23.3505 40 23.6685 40 24C40 24.3315 39.8683 24.6495 39.6339 24.8839C39.3995 25.1183 39.0815 25.25 38.75 25.25H33.438C33.2738 25.25 33.1113 25.2177 32.9596 25.1548C32.808 25.092 32.6702 25 32.5541 24.8839C32.438 24.7678 32.346 24.63 32.2831 24.4784C32.2203 24.3267 32.188 24.1642 32.188 24Z"
        fill="#979797"
      />
      <path
        opacity="0.4"
        d="M31.09 19.9084C30.9246 19.6217 30.8798 19.281 30.9652 18.9611C31.0507 18.6413 31.2596 18.3684 31.546 18.2024L36.146 15.5464C36.4315 15.3985 36.7631 15.3662 37.0717 15.4564C37.3804 15.5466 37.6424 15.7522 37.8034 16.0306C37.9643 16.309 38.0118 16.6387 37.9359 16.9511C37.8601 17.2636 37.6667 17.5348 37.396 17.7084L32.796 20.3644C32.6541 20.4466 32.4974 20.5 32.3348 20.5215C32.1722 20.5431 32.007 20.5324 31.8485 20.49C31.6901 20.4477 31.5415 20.3745 31.4114 20.2747C31.2813 20.1749 31.1721 20.0505 31.09 19.9084Z"
        fill="#979797"
      />
      <path
        opacity="0.3"
        d="M28.0941 16.9082C27.9521 16.8262 27.8276 16.717 27.7278 16.5868C27.6281 16.4567 27.5549 16.3081 27.5125 16.1497C27.4702 15.9913 27.4595 15.826 27.481 15.6634C27.5026 15.5009 27.556 15.3441 27.6381 15.2022L30.2941 10.6022C30.4599 10.3155 30.7328 10.1064 31.0527 10.0209C31.3726 9.93535 31.7134 9.98043 32.0001 10.1462C32.2868 10.312 32.4959 10.5848 32.5815 10.9048C32.667 11.2247 32.6219 11.5655 32.4561 11.8522L29.8001 16.4522C29.6341 16.7386 29.3613 16.9475 29.0414 17.033C28.7216 17.1185 28.3809 17.0736 28.0941 16.9082Z"
        fill="#979797"
      />
    </SpinCompWrap>
  );
};

export const FailComp: FC<{ className?: string; onClick?: () => void }> = ({
  className,
  onClick,
}) => {
  return (
    <svg
      onClick={() => onClick?.()}
      className={`${className} cursor-pointer`}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24Z"
        fill="#FF3B3B"
      />
      <path
        d="M26.1425 26.0051L26.7863 16.9924C26.9018 15.3754 25.6211 14 24 14C22.3789 14 21.0982 15.3754 21.2137 16.9924L21.8575 26.0051C21.9378 27.1291 22.8731 28 24 28C25.1269 28 26.0622 27.1291 26.1425 26.0051Z"
        fill="white"
      />
      <circle cx="24" cy="32" r="2" fill="white" />
    </svg>
  );
};

export const ReadTickComp: FC<{ className?: string; onClick?: () => void }> = ({
  className,
  onClick,
}) => {
  return (
    <svg
      onClick={() => onClick?.()}
      className={`${className} cursor-pointer`}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9996 15.9962L13.641 17.9689C14.3598 18.8327 15.649 18.935 16.4949 18.1952L27.6339 8.45491"
        stroke="#0054FC"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9557 16.8924C24.8624 17.8285 24.6289 18.7167 24.278 19.5383C22.7748 23.058 19.1178 25.3554 15.1078 24.9559C10.1617 24.4631 6.55157 20.0541 7.04432 15.108C7.53707 10.1619 11.9461 6.5518 16.8922 7.04455C18.1659 7.17144 19.351 7.55803 20.4002 8.14662"
        stroke="#0054FC"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SendComp: FC<{ className?: string; active?: boolean; onClick?: () => void }> = ({
  className,
  onClick,
  active,
}) => {
  return (
    <svg
      className={className}
      onClick={() => onClick?.()}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5303 3.07091L3.69011 9.19173C3.49015 9.26908 3.31776 9.40416 3.19489 9.57976C3.07202 9.75536 3.00425 9.96353 3.00019 10.1778C2.99614 10.392 3.05599 10.6026 3.17213 10.7827C3.28826 10.9628 3.45542 11.1043 3.65232 11.1891L10.051 13.9411L12.8157 20.3479C12.9007 20.5449 13.0424 20.7121 13.2229 20.8282C13.4033 20.9443 13.6143 21.004 13.8289 20.9998C14.0435 20.9955 14.2519 20.9275 14.4277 20.8043C14.6034 20.6812 14.7384 20.5085 14.8154 20.3083L20.928 4.46667C21.0031 4.27166 21.0199 4.05906 20.9764 3.85469C20.9329 3.65031 20.8309 3.46295 20.6829 3.31535C20.535 3.16775 20.3473 3.06625 20.1427 3.02318C19.9381 2.98011 19.7254 2.99731 19.5303 3.07271V3.07091ZM18.6628 5.33452L13.7697 18.0159L11.7034 13.2288L11.6278 13.0741C11.4347 12.7235 11.13 12.4472 10.762 12.289L5.98322 10.2332L18.6637 5.33452H18.6628Z"
        fill={active ? '#0054FC' : '#979797'}
      />
    </svg>
  );
};

export const Alert: FC<{ className?: string; onClick?: () => void }> = ({ className, onClick }) => {
  return (
    <svg
      onClick={() => onClick?.()}
      className={className}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.5" cy="8.39844" r="6.5" stroke="#FF6164" />
      <rect x="8" y="4.39844" width="1" height="6" rx="0.5" fill="#FF6164" />
      <rect x="8" y="11.3984" width="1" height="1" rx="0.5" fill="#FF6164" />
    </svg>
  );
};
